module.exports = __webpack_public_path__ + "static/gallery_08-thumb-b4647ae1f273198f0ae56ceb3b6eb67e.jpg";